module.exports = __webpack_public_path__ + "static/media/37.fec1be06.mp3";